// Function to get city options for a given postal code
import { CityOption, cityOptions, zipToCityMap } from "./codelists";

export const getCitiesByPostalCode = (postalCode: string): CityOption[] => {
  if (!postalCode || postalCode.length !== 5) {
    // If no valid postal code is provided, return all city options
    return cityOptions;
  }

  // Check if the postal code exists in our zipToCityMap
  if (!zipToCityMap[postalCode]) {
    console.log(`[CityFilter] No cities found for postal code: ${postalCode}`);
    return cityOptions;
  }

  // Get the city names for this postal code
  const cityNames = zipToCityMap[postalCode];
  console.log(
    `[CityFilter] Cities for postal code ${postalCode}: ${JSON.stringify(
      cityNames
    )}`
  );

  // Filter city options to only include those that match our postal code
  const filteredCityOptions: CityOption[] = [];

  // Always include the empty option
  if (cityOptions[0]) {
    filteredCityOptions.push(cityOptions[0]);
  }

  // Create a map of city names in lowercase to detect exact matches
  const cityOptionMap = new Map<string, CityOption>();
  cityOptions.forEach((city) => {
    cityOptionMap.set(city.text.toLowerCase(), city);
  });

  // If we can't find any matches in cityOptions, we'll build custom options
  const customCityOptions: CityOption[] = [];

  cityNames.forEach((cityName) => {
    // Try to find an exact match (case-insensitive)
    const exactMatch = cityOptionMap.get(cityName.toLowerCase());
    if (exactMatch) {
      filteredCityOptions.push(exactMatch);
    } else {
      // Try to find by inclusion
      let foundMatch = false;

      // Check if any city option includes this city name or vice versa
      for (const city of cityOptions) {
        if (
          (city.text.length > 2 &&
            cityName.toLowerCase().includes(city.text.toLowerCase())) ||
          (cityName.length > 2 &&
            city.text.toLowerCase().includes(cityName.toLowerCase()))
        ) {
          filteredCityOptions.push(city);
          foundMatch = true;
          break;
        }
      }

      // If no match in cityOptions, create a custom option
      if (!foundMatch) {
        // Generate a key from the name
        const key = cityName.toUpperCase().replace(/\s+/g, "_");
        customCityOptions.push({ key, text: cityName });
      }
    }
  });

  // Add all custom city options
  if (customCityOptions.length > 0) {
    // Add a separator option for visual distinction
    if (filteredCityOptions.length > 1) {
      filteredCityOptions.push({
        key: "SEPARATOR",
        text: "--- Cities for this postal code ---",
      });
    }

    // Add the custom options
    filteredCityOptions.push(...customCityOptions);
  }

  console.log(
    `[CityFilter] Filtered to ${filteredCityOptions.length} city options (including ${customCityOptions.length} custom options)`
  );

  // If we didn't find any matches at all, return all options to avoid empty dropdown
  return filteredCityOptions.length > 1 ? filteredCityOptions : cityOptions;
};
